import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import { handleFieldChange } from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: 'client',
            affid: null,
            subid: null,
            country: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e, type) {
        e.preventDefault();

        this.props.onSubmit(this.state, type);
    }

    render() {
        return (
            <form>
                <Row>
                    <Col lg={6}>
                        <SelectWrap
                            values={[ 'client', 'eclient' ]}
                            label="Type:"
                            name="type"
                            onChange={this.handleFieldChange}
                            value={this.state.type}
                            required
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                        <SelectWrap
                            values={this.props.subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            disabled={!this.props.subidValues.length || !this.state.affid || !this.state.affid.length}
                            multi
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button onClick={(e) => this.handleFormSubmit(e)} type="submit" bsStyle="info" className="m-b-15" >Apply</Button>
                    <Button onClick={(e) => this.handleFormSubmit(e, 'subid')} type="submit" bsStyle="info" className="m-b-15" disabled={!this.state.affid || !this.state.affid.length}>Load Subid</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/DynamicCutoffAll/components/Form/index.js